import styled from "styled-components";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Form } from "formik";

export const StyledLabel = styled(Typography)`
  color: #000000;
  font-family: "Lato-Black" !important;
  font-size: 18px !important;
  letter-spacing: 0.6px;

  @media only screen and (max-width: 1279.95px) {
    margin-bottom: 20px !important;
  }

  &.product-label {
    margin: -4px 0px 11px !important;
  }
`;

export const StyledFormLabel = styled(Typography)`
  span {
    color: #4a4a4a;
    font-family: "Lato";
    font-size: 23px;
    line-height: 29px;
    margin: -5px 0px 10px;
    letter-spacing: initial;
    position: relative;
    display: inline-block;
  }

  @media only screen and (max-width: 959.95px) {
    span {
      font-size: 18px;
    }
  }
`;

export const StyledForm = styled(Form)`
  margin-left: 8%;
  @media only screen and (max-width: 1279.95px) {
    margin-left: 0;
  }
  div {
    vertical-align: top;
  }
`;

export const StyledButtonsWrapper = styled(Grid)`
  margin: 51px -4px 42px !important;
`;

export const PercentageSymbol = styled(StyledFormLabel)`
  text-align: right;
  z-index: -1;
  margin: -55px -30px 20px 0px !important;

  @media only screen and (max-width: 1279.95px) {
    margin: -55px -25px 20px 0px !important;
  }

  @media only screen and (max-width: 959.95px) {
    margin: -55px -20px 20px 0px !important;
  }
`;

export const StyledDisclaimersWrapper = styled(Grid)`
  margin: 15px 0px !important;
  color: #0b0b0b;
  font-family: "Lato-Light";
  font-size: 19px;

  &.product-label {
    margin: 15px 0px 35px !important;
  }

  ul {
    @media only screen and (max-width: 599.95px) {
        margin-bottom: -8px;
        margin-top: 0px;
    }
  }

  p {
    font-size: 15px;
    &:last-child {
      margin-bottom: 35px;
    }
  }

  a {
    color: #0b0b0b !important;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  label {
    font-family: "Lato";
    color: #0b0b0b;
    font-size: 24px;
  }
`;
